import React, { FC } from 'react';
import { Box, TextField, Tooltip } from '@mui/material';
import { ADDITIONAL_FIELDS_META } from '../../model';
import { AdditionalFieldsSectionProps } from '../../types/additionalFieldsForm';
import { GRID_API_CAMPAIGN_LABEL } from '../../hooks/useGridApiCampaignField';
import { useAdditionalFieldsHandlers } from '../../hooks/useAdditionalFieldsHandlers';

type GridApiCampaignFieldProps = {
  gridApiCampaign: string;
  gridApiCampaignError: string | undefined;
  isGridApiCampaignDisabled: boolean;
  gridApiCampaignHelperText: string | undefined;
  handleGridApiCampaignChange: (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => void;
  handleGridApiCampaignBlur: () => Promise<void>;
  handleGridApiCampaignKeyDown: (
    event: React.KeyboardEvent<HTMLInputElement>,
  ) => Promise<void>;
};

type CampaignSectionProps = AdditionalFieldsSectionProps &
  GridApiCampaignFieldProps &
  Pick<
    ReturnType<typeof useAdditionalFieldsHandlers>,
    'handleTextChange' | 'handleBlur' | 'handleTextKeyDown'
  >;

export const CampaignSection: FC<CampaignSectionProps> = ({
  values,
  isFieldsDisabled,
  gridApiCampaign,
  gridApiCampaignError,
  isGridApiCampaignDisabled,
  gridApiCampaignHelperText,
  handleGridApiCampaignChange,
  handleGridApiCampaignBlur,
  handleGridApiCampaignKeyDown,
  handleTextChange,
  handleBlur,
  handleTextKeyDown,
}) => (
  <>
    <Box>
      <TextField
        label={ADDITIONAL_FIELDS_META.campaignName.label}
        variant="standard"
        fullWidth
        value={values.campaignName ?? ''}
        disabled={isFieldsDisabled}
        onChange={handleTextChange('campaignName')}
        onBlur={handleBlur('campaignName')}
        onKeyDown={handleTextKeyDown('campaignName')}
      />
    </Box>

    <Box>
      <Tooltip
        title={
          isGridApiCampaignDisabled
            ? 'Запись дополнительных полей карточки ещё не создана'
            : ''
        }
      >
        <Box component="span" display="block" width="100%">
          <TextField
            label={GRID_API_CAMPAIGN_LABEL}
            variant="standard"
            fullWidth
            value={gridApiCampaign}
            disabled={isGridApiCampaignDisabled}
            error={Boolean(gridApiCampaignError)}
            helperText={gridApiCampaignHelperText}
            onChange={handleGridApiCampaignChange}
            onBlur={handleGridApiCampaignBlur}
            onKeyDown={handleGridApiCampaignKeyDown}
          />
        </Box>
      </Tooltip>
    </Box>
  </>
);
